import { initialState } from "./state";
import { DroneEntity } from "@src/core/features";
import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { IUpsertMissionInitialState, TerrainMode } from "./types";
import { MissionStep, RouteWaypointEntity } from '@src/features/order/pages/upsert-mission-page/entities';

const resetState: CaseReducer<IUpsertMissionInitialState, PayloadAction> = () => initialState;

const setSelectedDrone: CaseReducer<IUpsertMissionInitialState, PayloadAction<DroneEntity | null>> = (state, action) => {
  state.selectedDrone = action.payload;
};

const setHoveredDrone: CaseReducer<IUpsertMissionInitialState, PayloadAction<DroneEntity | null>> = (state, action) => {
  state.hoveredDrone = action.payload;
};

const setActiveStep: CaseReducer<IUpsertMissionInitialState, PayloadAction<MissionStep>> = (state, action) => {
  state.activeStep = action.payload;
};

const setExpandedStep: CaseReducer<IUpsertMissionInitialState, PayloadAction<MissionStep>> = (state, action) => {
  state.expandedStep = action.payload;
};

const openMissionStep: CaseReducer<IUpsertMissionInitialState, PayloadAction<MissionStep>> = (state, action) => {
  state.activeStep = action.payload;
  state.expandedStep = action.payload;
};

const setWizardOrderId: CaseReducer<IUpsertMissionInitialState, PayloadAction<string | null>> = (state, action) => {
  state.wizardOrderId = action.payload;
};

const setWaypoints: CaseReducer<IUpsertMissionInitialState, PayloadAction<RouteWaypointEntity[]>> = (state, action) => {
  state.waypoints = action.payload;
};

const setEditableRoute: CaseReducer<IUpsertMissionInitialState, PayloadAction<boolean>> = (state, action) => {
  state.editableRoute = action.payload;
};

const setRouteModified: CaseReducer<IUpsertMissionInitialState, PayloadAction<boolean>> = (state, action) => {
  state.routeModified = action.payload;
};

const setTerrainMode: CaseReducer<IUpsertMissionInitialState, PayloadAction<TerrainMode>> = (state, action) => {
  state.terrainMode = action.payload;
};

export default {
  resetState,
  setSelectedDrone,
  setActiveStep,
  setExpandedStep,
  openMissionStep,
  setWizardOrderId,
  setWaypoints,
  setEditableRoute,
  setRouteModified,
  setHoveredDrone,
  setTerrainMode,
};